module.exports = __webpack_public_path__ + "img/Good Student Award 4.0b25fdf6.png";